import { BackboneHotelSearchRepository } from "@fr/vue/types/backboneModels/Domain/Repository"
import { FoundedHotelFilter } from '@ve/types';
export default function(hotels: BackboneHotelSearchRepository): FoundedHotelFilter[] {
    return hotels?.map((hotel) => {
        return {
            category: hotel.get('category')?.get('id'),
            country: hotel.get('country')?.get('id'),
            countryId: hotel.get('country')?.get('id'),
            countryName: hotel.get('country')?.get('name'),
            id: hotel.get('id'),
            isPopular: hotel.get('isPopular'),
            name: hotel.get('name'),
            resort: hotel.get('resort')?.get('id'),
            resortName: hotel.get('resort')?.get('name'),
        }
    }) || []
}